export default {"src":"/evde-internet/_next/static/media/tobi.e5db6860.svg","height":32,"width":32};